module.exports = __webpack_public_path__ + "static/20-4-4d2d651f8a50a6bfef48ad6d5d3d8b83.jpg";